import { render } from "./BlogsScreen.vue?vue&type=template&id=7a22016f&scoped=true"
import script from "./BlogsScreen.vue?vue&type=script&lang=js"
export * from "./BlogsScreen.vue?vue&type=script&lang=js"

import "./BlogsScreen.vue?vue&type=style&index=0&id=7a22016f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a22016f"]])

export default __exports__